












































import { Component, Mixins } from "vue-property-decorator";
import FormValidator from "@/mixins/FormValidator";
import { AuthModule } from "@/store/auth.module";

@Component({})
export default class WarningRestoreView extends Mixins(FormValidator) {
  public async clickBack() {
    this.$router.replace({ name: "auth" });
  }
}
